export default {
  getPolicies: (state) => state.policies,
  getPoliciesMeta: (state) => state.policiesMeta,
  getFiles: (state) => state.files,
  getPolicy: (state) => state.policy,
  getClaims: (state) => state.claims,
  getClaimsMeta: (state) => state.claimsMeta,
  getClaimsHistoriesClaim: (state) => state.claimsHistoriesClaim,
  getClaim: (state) => state.claim,
  getPartners: (state) => state.partners,
  getProducts: (state) => state.products,
  getProductCategories: (state) => state.productCategories,
  getUploadProgress: (state) => state.uploadProgress,
};
